import CardMeta from 'antd/es/card/Meta';

export default CardMeta;
